import React, { useState, useCallback, useEffect } from 'react';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import MemberVolunteerPoints from 'components/admin/reports/MemberVolunteerPoints';
import { exportVolunteerHoursReportToFile } from 'api/reportsApi';
import { getSeasons } from 'api/season';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import { exportAndDownloadFile } from 'utils/fileDownload';

const MemberVolunteerPointsPage = () => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const [seasons, setSeasons] = useState([]);
  const [reportData, setReportData] = useState(null);

  const fetchSeasons = useCallback(async () => {
    try {
      if (selectedClub) {
        const response = await getSeasons(selectedClub?.clubID || '');
        const seasonsData = response.data || [];
        const sortedSeasons = [...seasonsData].sort((a, b) => {
          if (a.status === 'Draft') return -1;
          if (b.status === 'Draft') return 1;
          if (a.status === 'Active') return -1;
          if (b.status === 'Active') return 1;
          return new Date(b.startDate) - new Date(a.startDate);
        });
        setSeasons(sortedSeasons);
      }
    } catch (err) {
      console.error('[Season] Fetch seasons error: ', err);
      toast.error('Failed to load seasons');
    }
  }, [selectedClub]);

  useEffect(() => {
    if (!seasons.length) {
      fetchSeasons();
    }
  }, [fetchSeasons, seasons]);

  const handleExportToFile = async () => {
    await exportAndDownloadFile(
      exportVolunteerHoursReportToFile,
      [
        selectedClub.clubID,
        null, // Let API determine current season
      ],
      '',
      'The volunteer hours report was successfully exported',
      'Fetching volunteer hours report data from the server...'
    );
  };

  const isExportButtonDisabled = !reportData || !reportData.hasData;

  // The season the report actually shows (the component auto-selects the
  // active season and reports its id back up).
  const reportSeasonName =
    seasons.find((s) => s.seasonID === reportData?.selectedSeasonID)?.name || '';

  return (
    <>
      <MetaTags title="SplitFast | Member Volunteer Points Report" />
      <MainContent>
        <PageHeader
          title="Member Volunteer Hours Report"
          subTitle={reportSeasonName}
          primarySubTitle
        >
          <CustomNewButton
            variant="info"
            onClick={handleExportToFile}
            label="Export to file"
            disabled={isExportButtonDisabled}
          />
        </PageHeader>
        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }}/>
        ) : (
          <MemberVolunteerPoints
            seasons={seasons}
            clubID={selectedClub?.clubID}
            onDataChange={setReportData}
          />
        )}
      </MainContent>
    </>
  );
};

export default MemberVolunteerPointsPage;